module.exports = __webpack_public_path__ + "img/TradingView-icon1.f4d638a0.svg";